import { Row } from '@tanstack/react-table';
import { UpdateJobItem } from '../../windows-updates/models/update-job-item';
import { JobStatus } from '../types/backend/jobStatus';

const jobStatusMap = {
  [JobStatus.None]: 1,
  [JobStatus.Failed]: 2,
  [JobStatus.PartiallySuccessful]: 3,
  [JobStatus.Successful]: 4,
  [JobStatus.Cancelled]: 5,
  [JobStatus.Scheduled]: 6,
  [JobStatus.Running]: 7
};

export function sortByJobStatus(a: Row<UpdateJobItem>, b: Row<UpdateJobItem>): number {
  const aValue = jobStatusMap[a.original.jobStatus];
  const bValue = jobStatusMap[b.original.jobStatus];
  if (aValue == bValue) {
    if (a.original.jobStatus === JobStatus.PartiallySuccessful) {
      const difference = b.original.jobRunStatistics.failedUpdateCount - a.original.jobRunStatistics.failedUpdateCount;
      if (difference != 0) {
        return difference;
      }
    }
    return a.original.finishedAt && b.original.finishedAt
      ? b.original.finishedAt.getTime() - a.original.finishedAt.getTime()
      : 0;
  }
  return aValue - bValue;
}

function calculateJobProgressValue(row: Row<UpdateJobItem>): number {
  return row.original.jobRunStatistics.successfulUpdateCount / row.original.jobRunStatistics.totalUpdateCount;
}

export function sortByJobProgress(a: Row<UpdateJobItem>, b: Row<UpdateJobItem>): number {
  const aValue = calculateJobProgressValue(a);
  const bValue = calculateJobProgressValue(b);
  if (aValue == bValue) {
    return a.original.finishedAt && b.original.finishedAt
      ? b.original.finishedAt.getTime() - a.original.finishedAt.getTime()
      : 0;
  }
  return aValue - bValue;
}
